import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

export const ArchivedIcon = (props: IconProps) => {
  return (
    <Icon viewBox="0 0 83 83" fill="none" xmlns="http://www.w3.org/2000/Icon" {...props}>
      <g clipPath="url(#a)" fill="currentColor">
        <path d="M47.725 66.4h-12.45a2.076 2.076 0 0 1 0-4.15h12.45a2.076 2.076 0 0 1 0 4.15Z" />
        <path d="M81.162 47.24 69.965 21.641c-1.237-2.83-4.627-5.046-7.715-5.046h-41.5c-3.088 0-6.478 2.216-7.715 5.046L1.838 47.24C.81 49.597 0 53.452 0 56.025v16.6a6.233 6.233 0 0 0 6.225 6.225h70.55A6.233 6.233 0 0 0 83 72.625v-16.6c0-2.569-.805-6.428-1.838-8.786ZM16.837 23.31c.585-1.34 2.452-2.56 3.913-2.56h41.5c1.46 0 3.328 1.22 3.913 2.56L77.36 48.908c.125.286.25.614.37.967a6.046 6.046 0 0 0-.955-.075H6.225c-.324 0-.643.025-.954.075.12-.353.24-.681.369-.967L16.837 23.31ZM78.85 72.625c0 1.145-.93 2.075-2.075 2.075H6.225a2.076 2.076 0 0 1-2.075-2.075v-16.6c0-1.145.93-2.075 2.075-2.075h70.55c1.145 0 2.075.93 2.075 2.075v16.6Z" />
        <path d="M68.475 45.65h-53.95a2.076 2.076 0 0 1 0-4.15h53.95a2.076 2.076 0 0 1 0 4.15ZM64.325 37.35h-45.65a2.076 2.076 0 0 1 0-4.15h45.65a2.076 2.076 0 0 1 0 4.15ZM60.175 29.05h-37.35a2.076 2.076 0 0 1 0-4.15h37.35a2.076 2.076 0 0 1 0 4.15Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="currentColor" d="M0 0h83v83H0z" />
        </clipPath>
      </defs>
    </Icon>
  );
};
